<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="value"
        :label="name"
        readonly
        filled
        v-bind="attrs"
        v-on="on"
        @click="$emit('focus')"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" no-title scrollable>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false; $emit('input', null)">Отмена</v-btn>
      <v-btn text color="primary" @click="menu = false; $emit('input', date)">ОК</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'date-picker',
  props: {
    value: String,
    name: String,
    disabled: Boolean
  },

  data() {
    return {
      date: this.value,
      menu: false,
    }
  },
}
</script>